import { Outlet, useNavigate } from 'react-router-dom';
import { ProfessionalHeader } from '@/components/ui/ProfessionalHeader';
import { useLayoutEffect } from 'react';
import { setProfessionalData } from '@/utils/cookies';
import { useGetMe } from '@/services';
import { ProfessionalCalendarProvider } from '@/context/ProfessionalCalendarContext';

const ProfessionalLayout = () => {
	const navigate = useNavigate();
	const { data, isLoading } = useGetMe();

	useLayoutEffect(() => {
		if (!isLoading) {
			if (data) {
				setProfessionalData(data);
				if (data.authorized) {
					const pathname =
						typeof window !== 'undefined'
							? window.location.pathname
							: '';
					if (
						pathname === '/profissional' ||
						pathname === '/profissional/'
					) {
						navigate('/profissional/home', { replace: true });
					}
					return;
				}
				navigate('/profissional/autorizacao', { replace: true });
				return;
			}
			navigate('/profissional/login', { replace: true });
		}
	}, [isLoading, data, navigate]);

	if (!data) return null;

	return (
		<ProfessionalCalendarProvider>
			<section className="flex min-h-screen w-full flex-col overflow-x-hidden bg-zinc-50">
				<ProfessionalHeader />
				<main className="flex h-[calc(100vh-68px)] w-full">
					<section className="z-0 m-auto h-[calc(100vh-68px)] w-full flex-1 overflow-y-scroll">
						<Outlet context={{ data, isLoading }} />
					</section>
				</main>
			</section>
		</ProfessionalCalendarProvider>
	);
};

export { ProfessionalLayout };
